<template>
  <b-card>
    <b-card-title>Re-Assign driver</b-card-title>
    <b-row>
      <b-col md="9">
        <v-select
          v-model="selectedDriver"
          placeholder="Select Driver"
          :options="nearDrivers"
          :loading="fetching"
          :get-option-label="(option) => `${option.phone_number} / Acceptance Ratio: ${option.acceptance_ratio}`"
        />
      </b-col>
      <b-col md="3">
        <b-button
          :disabled="!selectedDriver || assigning"
          variant="primary"
          @click="assignHandler"
        >
          <b-spinner
            v-if="assigning"
            small
          />
          <span v-else>Assign</span>
        </b-button>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { inject, ref } from '@vue/composition-api'
import {
  BCard, BCardTitle, BRow, BCol, BButton, BSpinner,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import axiosIns from '@/libs/axios'
import { errorNotification, successNotification } from '@/utils/toast-notifications'

export default {
  components: {
    BCard,
    BSpinner,
    BCardTitle,
    vSelect,
    BButton,
    BRow,
    BCol,
  },
  setup(_, ctx) {
    const trip = inject('trip')

    const { location, service } = trip.value.metadata
    const getNearestDriverData = {
      pickupLat: location.pickup.latitude,
      pickupLng: location.pickup.longitude,
      serviceName: service.name,
      serviceClass: service.class,
    }
    const nearDrivers = ref([])
    const fetching = ref(false)
    const selectedDriver = ref()
    const getNearestDriver = async () => {
      fetching.value = true
      const res = await axiosIns.get('drivers/nearest-driver', {
        params: getNearestDriverData,
      })
      const { data } = res.data
      nearDrivers.value = data
      fetching.value = false
    }
    getNearestDriver()

    const assigning = ref(false)
    const assignHandler = async () => {
      const body = {
        tripId: trip.value.id,
        driver: selectedDriver.value,
      }
      try {
        assigning.value = true
        await axiosIns.post('/trips/assign-driver', body)
        successNotification('Trip Assigned Successfully')
        await ctx.root.$store.dispatch('trips/fetchTripDetails')
      } catch (error) {
        const { error_message: errMsg } = error.response.data
        errorNotification(errMsg || 'An error occured while re-assigning')
      } finally {
        assigning.value = false
      }
    }
    return {
      nearDrivers,
      assignHandler,
      selectedDriver,
      assigning,
      fetching,
    }
  },
}
</script>
